var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",style:({height:_vm.params.frameHeight+'px', width: _vm.params.frameWidth+'px'})},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imgSrc}}),_vm._v(" "),_c('a-spin',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading",attrs:{"size":"large","tip":"正在加载..."}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec95c2da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/design/PreviewR.vue
// module id = null
// module chunks = 